import { OnInit, Inject, Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { MaterialModule } from './material.module';
import { MatContainerModule } from './controls/mat-container';

export class CustomDialogClass<T> implements OnInit {
    FData: any;
    get data() {
        return this.FData;
    }
    set data(x) {
        this.FData = x;
    }
    constructor(
        public dialogRef: MatDialogRef<T>,
        @Inject(MAT_DIALOG_DATA) public aData: any,
    ) {
        this.data = aData;
    }
    ngOnInit(): void { }

    public static openDialog(dialog: MatDialog, refClass, data?, beforeProc?): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '450px';
        dialogConfig.data = data;
        if (beforeProc) beforeProc(dialogConfig);
        var dlg = dialog.open(refClass, dialogConfig);
        return dlg.afterClosed();
    }


    cancel(x?): void {
        this.dialogRef.close(x);
    }

    ok(x) {
        this.dialogRef.close(x);
    }
}


@Component({
    selector: 'sim-nao-dialog',
    template: `
    <mat-card>
      <mat-card-title>
       {{title}}
      </mat-card-title> 
    <mat-card-content>
      <ng-content></ng-content>
      {{content}}
    </mat-card-content>
    <mat-card-actions>
      <button mat-button (click)="ok(true)"> <mat-icon class="mat-18">done</mat-icon> Sim </button>
      <button mat-button (click)="cancel(false)"><mat-icon class="mat-18">cancel</mat-icon>Não</button>
    </mat-card-actions>
    </mat-card>`,
    styles: [``]
})
export class SimNaoDialog extends CustomDialogClass<SimNaoDialog> implements OnInit {
    @Input()
    title: string = '';
    @Input()
    content:string='';
    constructor(
        public aDialogRef: MatDialogRef<SimNaoDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super(aDialogRef, data);
    }

    ngOnInit(): void { }

    public static open(dialog: MatDialog,content?:string,title?:string, data:any={}, respProc?) {
        if (content)
          data.content = content;
        if (title)
          data.title = title;
        var dlg = CustomDialogClass.openDialog(dialog, SimNaoDialog, data);
        if (respProc)
            dlg.subscribe(r => {
                respProc(r);
            });
        return dlg;
    }

}

@Component({
    selector: 'ok-dialog',
    template: `
    <mat-container>
      <mat-title>
       {{title}}
      </mat-title> 
    <mat-content>
      <ng-content></ng-content>
      {{content}}
    </mat-content>
    <mat-actions>
      <button mat-button (click)="ok(true)"> <mat-icon class="mat-18">done</mat-icon> OK</button>
    </mat-actions>
    </mat-container>`,
    styles: [``]
})
export class OkDialog extends CustomDialogClass<OkDialog> implements OnInit {
    @Input()
    title: string = 'Informação';
    @Input()
    content:string='';
    constructor(
        public aDialogRef: MatDialogRef<OkDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super(aDialogRef, data);
        if (data.title)
          this.title = data.title;
        if (data.content)
          this.content = data.content;  
    }

    ngOnInit(): void { }

    public static open(dialog: MatDialog,content?:string,title?:string, data:any={}, respProc?) {
        if (content)
          data.content = content;
        if (title)
          data.title = title;
        var dlg = CustomDialogClass.openDialog(dialog, OkDialog, data);
        if (respProc)
            dlg.subscribe(r => {
                respProc(r);
            });
        return dlg;
    }

}


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
@NgModule({
    declarations: [        
        SimNaoDialog,
        OkDialog,
],
    imports: [
        CommonModule, 
        MaterialModule,
        MatContainerModule
    ],
    exports: [SimNaoDialog,OkDialog],

    providers: [],
    entryComponents: [
        SimNaoDialog,
        OkDialog,
    ],
    schemas:[
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class CustomDialogModule { }